export default "__VITE_ASSET__2Oa2QMJ5__"